import axios from 'axios';
import store from '../store';
import addError from './AddError';

export const PURCHASE_REQUESTED = 'PURCHASE_REQUESTED';
export const PURCHASE_COMPLETED = 'PURCHASE_COMPLETED';
export const PURCHASE_FAILED = 'PURCHASE_FAILED';

const purchaseLeads = days => (
  (dispatch) => {
    dispatch({
      type: PURCHASE_REQUESTED,
    });

    return axios
      .post('/api/leads/bulk-leads/purchase', { days })
      .then(() => {
        dispatch({
          type: PURCHASE_COMPLETED,
        });
      }).catch((error) => {
        dispatch({
          type: PURCHASE_FAILED,
        });

        return store.dispatch(addError({
          text: 'Unable to purchase leads',
          originalError: error,
        }));
      });
  }
);

export default purchaseLeads;
